export enum ApprovalType {
  Pending = 0,
  Approved = 1,
  Rejected = 2,
  Removed = 3,
}

export const ApprovalTypeDescriptions: { [key in ApprovalType]: string } = {
  [ApprovalType.Pending]: 'Pending',
  [ApprovalType.Approved]: 'Approved',
  [ApprovalType.Rejected]: 'Rejected',
  [ApprovalType.Removed]: 'Removed',
};
